module.exports = __webpack_public_path__ + "static/media/06.e21f0df0.png";